import { useBranding } from "@/context/BrandingContext";
import { cn } from "@/lib/utils";

// Renders the official MLILY logo (never stretched/cropped) + optional title/subtitle.
export default function BrandLogo({ size = 40, showText = true, dark = false, className = "" }) {
  const { title, subtitle, logoUrl } = useBranding();
  return (
    <div className={cn("flex items-center gap-2.5", className)} data-testid="brand-logo">
      <img
        src={logoUrl}
        alt={title}
        style={{ width: size, height: size }}
        className="object-contain rounded-lg shrink-0"
      />
      {showText && (
        <div className="leading-tight">
          <div className={cn("font-heading font-extrabold text-sm", dark ? "text-white" : "text-slate-900")}>{title}</div>
          <div className={cn("text-[11px] -mt-0.5", dark ? "text-blue-100" : "text-slate-500")}>{subtitle}</div>
        </div>
      )}
    </div>
  );
}
